import { getBanners } from './banners';
import {
  getAboutCompany,
  getAMLManual,
  getCashbackRules,
  getGeneralTerms,
  getOffer,
  getPrivacyPolicy,
  getPromotion,
  getResponsibleGaming,
  getTermsOfService,
} from './documents';
import { getPaymentPromotions } from './payment-promotions';
import { getSlides } from './slides';
import { getVideos } from './videos';


export const strapiServices = {
  banners: {
    getBanners,
  },
  slides: {
    getSlides,
  },
  paymentPromotions: {
    getPaymentPromotions,
  },
  documents: {
    getPrivacyPolicy,
    getAMLManual,
    getGeneralTerms,
    getResponsibleGaming,
    getTermsOfService,
    getAboutCompany,
    getOffer,
    getCashbackRules,
    getPromotion,
  },
  videos: {
    getVideos,
  },
};
